export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  features: string[];
  imageSeq: string;
}

export interface Article {
  slug: string;
  title: string;
  summary: string;
  content: string;
  category: string;
  date: string;
  author: string;
  imageSeq: string;
}

export interface FAQ {
  question: string;
  answer: string;
}

export interface Promotion {
  title: string;
  description: string;
  tag: string;
  imageSeq: string;
}

export const siteInfo = {
  name: '必赢亚洲',
  description: '必赢亚洲是亚洲顶级娱乐游戏平台，提供体育竞技、真人娱乐、电子游艺等多元玩法。必赢亚洲官方正版授权，安全存取款，极速到账，24小时客服全程护航，让每一位玩家体验公平、刺激、高赔率的顶级娱乐盛宴。',
  keywords: '必赢亚洲,必赢亚洲官网,必赢亚洲注册,必赢亚洲登录入口,必赢亚洲体育投注,必赢亚洲真人娱乐,必赢亚洲优惠活动',
  url: 'https://www.biyingyazhou.com',
  email: 'service@biyingyazhou.com',
  phone: '400-888-9999',
  address: '菲律宾马尼拉博彩监管区',
  year: 2026,
};

export const categories: Category[] = [
  {
    slug: 'sports',
    name: '体育竞技',
    description: '覆盖全球各大体育赛事，足球、篮球、网球、电竞等热门项目，实时赔率更新，让您尽情享受体育投注的激情与乐趣。',
    icon: 'ri-football-line',
    features: ['全球赛事覆盖', '实时赔率更新', '多种投注玩法', '高清直播同步'],
    imageSeq: 'category-sports-2026',
  },
  {
    slug: 'live-casino',
    name: '真人娱乐',
    description: '专业荷官在线发牌，百家乐、轮盘、骰宝等经典娱乐项目，高清实时视频传输，打造身临其境的沉浸式娱乐体验。',
    icon: 'ri-vip-crown-line',
    features: ['真人荷官发牌', '高清实时画面', '多台同屏', '即时语音互动'],
    imageSeq: 'category-live-2026',
  },
  {
    slug: 'slots',
    name: '电子游艺',
    description: '海量精品电子游艺，老虎机、捕鱼、棋牌等多种玩法，精美画面与丰富奖励机制，随时随地畅享指尖乐趣。',
    icon: 'ri-gamepad-line',
    features: ['千款精品游戏', '精美视觉特效', '高额奖金机制', '即点即玩体验'],
    imageSeq: 'category-slots-2026',
  },
  {
    slug: 'promotions',
    name: '优惠活动',
    description: '新会员注册即享丰厚大礼包，每日签到、每周返利、节日专属福利等超值优惠活动不间断，让您的每一次游戏都物超所值。',
    icon: 'ri-gift-line',
    features: ['新会员大礼包', '每日签到奖励', '周周返利计划', '节日专属福利'],
    imageSeq: 'category-promo-2026',
  },
];

export const articles: Article[] = [
  {
    slug: 'welcome-bonus-2026',
    title: '必赢亚洲新会员专享：注册即送1888元大礼包，限时抢购中',
    summary: '即日起，新注册必赢亚洲会员即可领取总价值1888元的豪华大礼包，包含首存红利、免费旋转等多重好礼，先到先得。',
    content: `<p>必赢亚洲作为亚洲顶级娱乐平台，始终致力于为新老会员提供最优质的游戏体验和最丰厚的奖励回馈。即日起，平台推出全新会员专享福利活动。</p>
<h2>活动详情</h2>
<p>凡通过必赢亚洲官网或必赢亚洲注册入口完成注册的新用户，均可获得总价值1888元的豪华大礼包。大礼包包含以下丰厚奖励：</p>
<ul>
<li><strong>首存红利：</strong>首次充值即享100%匹配红利，最高可获888元赠金</li>
<li><strong>免费旋转：</strong>电子游艺专区赠送100次免费旋转机会</li>
<li><strong>真人娱乐体验金：</strong>真人娱乐专区赠送500元体验金</li>
<li><strong>VIP会员体验：</strong>免费享受7天VIP会员权益</li>
</ul>
<h2>参与方式</h2>
<p>只需简单三步即可领取大礼包：访问必赢亚洲官网 → 点击注册按钮完成账号注册 → 在活动页面领取礼包。奖励将自动发放至您的账户，无需额外操作。</p>
<h2>注意事项</h2>
<p>活动时间有限，礼品数量有限，先到先得。每位新用户仅限参与一次。详情请查看活动规则页面或联系24小时在线客服咨询。</p>`,
    category: 'promotions',
    date: '2026-08-01',
    author: '必赢亚洲编辑部',
    imageSeq: 'article-bonus-2026',
  },
  {
    slug: 'sports-betting-guide',
    title: '体育竞技投注攻略：从入门到精通，掌握五大核心技巧',
    summary: '想要在必赢亚洲体育投注中获得更好体验？本文为您详细解析体育竞技投注的五大核心技巧，助您快速上手。',
    content: `<p>体育竞技投注是必赢亚洲最受欢迎的游戏品类之一。无论您是初次接触体育投注的新手，还是有一定经验的玩家，掌握以下五大核心技巧，都能帮助您更好地享受体育竞技的乐趣。</p>
<h2>技巧一：了解赛事基本面</h2>
<p>在投注任何一场比赛前，建议充分了解参赛队伍或选手的基本信息，包括近期状态、历史交锋记录、伤病情况等。必赢亚洲体育竞技专区提供详尽的赛事数据，帮助您做出更明智的判断。</p>
<h2>技巧二：合理管理资金</h2>
<p>设定明确的预算并严格遵守是长期稳定体验的关键。建议每次投注金额控制在总预算的5%以内，避免情绪化决策。</p>
<h2>技巧三：掌握赔率变化</h2>
<p>赔率反映了市场对比赛结果的预期。必赢亚洲提供实时赔率更新，关注赔率变化趋势能帮助您把握最佳投注时机。</p>
<h2>技巧四：多元化投注策略</h2>
<p>不要局限于单一玩法。必赢亚洲体育竞技提供胜平负、让球、大小球、半全场等多种投注方式，合理组合能有效分散风险。</p>
<h2>技巧五：善用平台工具</h2>
<p>必赢亚洲为玩家提供了丰富的辅助工具，包括实时比分、赛事直播、数据分析等，充分利用这些工具能显著提升您的体验。</p>`,
    category: 'sports',
    date: '2026-07-28',
    author: '必赢亚洲编辑部',
    imageSeq: 'article-sports-2026',
  },
  {
    slug: 'live-casino-experience',
    title: '真人娱乐新体验：揭秘必赢亚洲高清真人娱乐场的沉浸式魅力',
    summary: '必赢亚洲真人娱乐专区采用国际领先的实时视频传输技术，为您呈现堪比现场的沉浸式娱乐体验。',
    content: `<p>随着互联网技术的发展，真人娱乐已经不再局限于线下娱乐场。必赢亚洲真人娱乐专区通过先进的技术手段，将真实的娱乐体验搬到了线上。</p>
<h2>顶尖技术支撑</h2>
<p>必赢亚洲真人娱乐采用国际领先的高清实时视频传输技术，画面清晰流畅，延迟低至毫秒级。多机位拍摄确保您不错过任何一个精彩细节。</p>
<h2>专业荷官团队</h2>
<p>所有荷官均经过严格筛选与专业培训，具备丰富的从业经验。标准化的操作流程确保每一局游戏公平公正，亲切的互动方式让您感受到家一般的温暖。</p>
<h2>丰富的游戏选择</h2>
<p>必赢亚洲真人娱乐涵盖百家乐、轮盘、骰宝、龙虎斗、德州扑克等数十种经典游戏，满足不同玩家的偏好。多台同屏功能让您可以同时参与多个游戏房间。</p>
<h2>安全可靠的环境</h2>
<p>平台采用银行级加密技术保护用户数据安全，所有游戏结果均由权威第三方机构认证，确保每一局游戏都公开透明。</p>`,
    category: 'live-casino',
    date: '2026-07-25',
    author: '必赢亚洲编辑部',
    imageSeq: 'article-live-2026',
  },
  {
    slug: 'slot-games-top10',
    title: '电子游艺热门游戏TOP10：2026年必赢亚洲最受欢迎游戏榜单',
    summary: '盘点2026年必赢亚洲电子游艺专区最受欢迎的十大游戏，每一款都值得您亲自体验。',
    content: `<p>电子游艺以其精美的画面、丰富的玩法和诱人的奖励机制，成为必赢亚洲平台增长最快的游戏品类。以下是2026年上半年度最受欢迎的十大电子游艺游戏。</p>
<h2>榜单前十名</h2>
<ol>
<li><strong>金狮王传奇：</strong>以东方神兽为主题，精美的画面和丰富的免费旋转机制使其稳居榜首。</li>
<li><strong>深海探秘：</strong>海底世界主题，创新的累进奖池系统让玩家欲罢不能。</li>
<li><strong>水果忍者老虎机：</strong>经典水果主题与现代化玩法完美结合，简单易上手。</li>
<li><strong>埃及宝藏：</strong>古埃及神秘主题，多重奖励关卡设计精妙。</li>
<li><strong>幸运777：</strong>经典复古风格，回归老虎机最纯粹的游戏乐趣。</li>
<li><strong>星际征途：</strong>科幻太空主题，超高倍率让每一次旋转都充满期待。</li>
<li><strong>财神到：</strong>中国传统文化主题，特别受亚洲玩家欢迎。</li>
<li><strong>丛林冒险：</strong>热带雨林探险主题，画面精美，趣味性强。</li>
<li><strong>魔法学院：</strong>魔法奇幻主题，丰富的剧情线让游戏充满故事性。</li>
<li><strong>欢乐派对：</strong>轻松愉快的派对主题，适合休闲放松时游玩。</li>
</ol>
<p>以上所有游戏均可在必赢亚洲电子游艺专区找到，新用户还可享受免费旋转体验机会。</p>`,
    category: 'slots',
    date: '2026-07-20',
    author: '必赢亚洲编辑部',
    imageSeq: 'article-slots-2026',
  },
  {
    slug: 'payment-guide',
    title: '必赢亚洲存取款指南：多种支付方式，安全快捷到账',
    summary: '了解必赢亚洲支持的多种存取款方式，掌握极速到账的操作技巧，让您的资金流转更高效。',
    content: `<p>必赢亚洲深知资金安全对于每一位玩家的至关重要。平台提供多种安全便捷的存取款方式，并采用银行级加密技术，确保您的每一笔资金都安全无忧。</p>
<h2>支持的存款方式</h2>
<ul>
<li><strong>在线银行转账：</strong>支持国内外主流银行，实时到账</li>
<li><strong>电子钱包：</strong>支持多种主流电子钱包，操作便捷</li>
<li><strong>加密货币：</strong>支持USDT等主流加密货币，匿名安全</li>
<li><strong>线下充值：</strong>部分地区支持线下代理充值服务</li>
</ul>
<h2>取款流程</h2>
<p>取款流程简单高效：登录账户 → 进入取款页面 → 选择取款方式 → 输入金额 → 确认提交。通常情况下，取款申请将在30分钟内处理完成。</p>
<h2>安全保障</h2>
<p>必赢亚洲采用128位SSL加密技术保护用户数据，所有资金操作均需经过多重验证，确保账户资金万无一失。</p>`,
    category: 'promotions',
    date: '2026-07-15',
    author: '必赢亚洲编辑部',
    imageSeq: 'article-payment-2026',
  },
  {
    slug: 'responsible-gaming',
    title: '必赢亚洲责任游戏承诺：健康娱乐，理性参与',
    summary: '必赢亚洲始终坚持"健康娱乐、理性参与"的理念，为玩家提供全面的责任游戏保障措施。',
    content: `<p>必赢亚洲作为负责任的娱乐平台，始终将玩家的身心健康放在首位。我们倡导"健康娱乐、理性参与"的理念，并建立了完善的责任游戏保障体系。</p>
<h2>我们的承诺</h2>
<ul>
<li><strong>年龄限制：</strong>严格禁止未满18周岁的用户注册和使用平台服务</li>
<li><strong>自我限制：</strong>提供存款限额、投注限额、时间限额等多种自我管控工具</li>
<li><strong>冷静期设置：</strong>玩家可自主设置7天至6个月不等的冷静期</li>
<li><strong>专业咨询：</strong>与多家专业心理咨询机构合作，为有需要的玩家提供免费咨询服务</li>
</ul>
<h2>识别问题信号</h2>
<p>如果您发现自己或身边的人出现以下情况，建议及时寻求帮助：花费超过承受能力的时间和金钱、因游戏影响正常工作和生活、尝试"追回"损失而不断加大投入。</p>
<p>必赢亚洲始终陪伴在每一位玩家身边，让娱乐回归快乐本质。</p>`,
    category: 'promotions',
    date: '2026-07-10',
    author: '必赢亚洲编辑部',
    imageSeq: 'article-responsible-2026',
  },
];

export const faqs: FAQ[] = [
  {
    question: '如何在必赢亚洲注册账号？',
    answer: '访问必赢亚洲官网，点击右上角"注册"按钮，填写基本信息（用户名、密码、联系方式），完成手机或邮箱验证后即可成功注册。整个过程只需2-3分钟。注册后即可享受新会员专属福利。',
  },
  {
    question: '必赢亚洲支持哪些存取款方式？',
    answer: '必赢亚洲支持多种存取款方式，包括在线银行转账、电子钱包、加密货币等。存款实时到账，取款最快30分钟内处理完成。具体支持方式请查看存取款页面或咨询24小时在线客服。',
  },
  {
    question: '必赢亚洲是否安全可靠？',
    answer: '必赢亚洲持有正规运营牌照，采用银行级128位SSL加密技术保护用户数据，所有游戏结果由权威第三方机构认证。平台运营多年来已服务数百万用户，信誉卓著，安全可靠。',
  },
  {
    question: '忘记密码怎么办？',
    answer: '在登录页面点击"忘记密码"，输入注册时使用的手机号或邮箱，系统将发送验证码。验证通过后即可重新设置密码。如遇任何问题，可联系24小时在线客服协助处理。',
  },
  {
    question: '如何联系必赢亚洲客服？',
    answer: '必赢亚洲提供7×24小时全天候客服服务。您可以通过在线客服聊天、官方邮箱service@biyingyazhou.com或客服热线400-888-9999与我们取得联系。我们的客服团队将竭诚为您服务。',
  },
  {
    question: '必赢亚洲有哪些优惠活动？',
    answer: '必赢亚洲定期推出丰富多样的优惠活动，包括新会员注册礼包、首存红利、每日签到奖励、周周返利、节日专属福利等。建议关注官网优惠活动页面或订阅邮件通知，第一时间获取最新优惠信息。',
  },
];

export const promotions: Promotion[] = [
  {
    title: '新会员注册大礼包',
    description: '即日起注册即送1888元豪华礼包，含首存红利、免费旋转等多重好礼',
    tag: '限时',
    imageSeq: 'promo-newbie-2026',
  },
  {
    title: '每日签到领好礼',
    description: '连续签到7天可获最高888元奖励，每日惊喜不断',
    tag: '热门',
    imageSeq: 'promo-daily-2026',
  },
  {
    title: '周周返利计划',
    description: '每周累计投注额越高，返利比例越丰厚，最高可达1.2%',
    tag: '推荐',
    imageSeq: 'promo-weekly-2026',
  },
];

export const aboutInfo = {
  intro: `必赢亚洲成立于2015年，总部位于菲律宾马尼拉，是亚洲领先的综合娱乐游戏平台。经过多年的稳健发展，必赢亚洲已成长为集体育竞技、真人娱乐、电子游艺于一体的多元化娱乐品牌，服务覆盖亚洲多个国家和地区。`,
  mission: '以科技创新驱动娱乐体验升级，为亚洲玩家打造安全、公平、高品质的一站式娱乐平台。',
  vision: '成为亚洲最受信赖的综合娱乐品牌，让每一位玩家都能在必赢亚洲享受极致的娱乐体验。',
  licenses: [
    { name: '菲律宾博彩监管委员会（PAGCOR）牌照', code: 'PAGCOR-2025-0888' },
    { name: '马耳他博彩管理局（MGA）认证', code: 'MGA/B2C/456/2024' },
    { name: '国际博彩诚信协会（IGA）会员', code: 'IGA-2024-MEM-1288' },
  ],
  milestones: [
    { year: '2015', event: '必赢亚洲平台正式上线运营' },
    { year: '2017', event: '注册用户突破100万，推出真人娱乐专区' },
    { year: '2019', event: '获得PAGCOR正规运营牌照' },
    { year: '2021', event: '上线电子游艺专区，游戏数量突破1000款' },
    { year: '2023', event: '注册用户突破500万，获MGA国际认证' },
    { year: '2025', event: '全面升级平台技术架构，推出AI智能客服系统' },
    { year: '2026', event: '持续引领亚洲娱乐行业创新，推出多项行业首创功能' },
  ],
};